<footer *ngIf="!param">
    <!-- <div class="container">
        <h3>Download the app now!</h3>
        <span>Available for iOS and Android </span>
        <div class="stores">
            <a href="https://play.google.com/store/apps/details?id=com.milesblue.milesblue" target="_blank">
                <img src="./assets/img/cryptmi/store-google.webp" alt="">
            </a>
            <a href="https://apps.apple.com/us/app/cryptmiapp/id1586988515" target="_blank">
                <img src="./assets/img/cryptmi/store-apple.webp" alt="">
            </a>
        </div>
    </div> -->
    <img class="gennius-logofooter" src="./assets/img/logo-gennius.svg" alt="gennius">
    <div class="container links borde-top">
        <div class="bl-items">
            <div class="items">
                <a pageScroll href="#solutions" [routerLink]="['/solutions']">Solution</a>
                <!-- <a pageScroll href="#cryptmi" [routerLink]="['/cryptmi']">cryptMi</a> -->
                <a pageScroll href="#visa-client" [routerLink]="['/visa-client']">Visa Client</a>

            </div>
            <div class="items">
                <a pageScroll href="#mena-region" [routerLink]="['/mena-region']">MENA Region</a>
                <a pageScroll href="#the-world-as-one" [routerLink]="['/the-world-as-one']">The World as One</a>
            </div>
            <div class="items">
                <a pageScroll href="#imagine-app" [routerLink]="['/imagine-app']">Imagine App</a>
                <a pageScroll href="#gmix" [routerLink]="['/gmix']">One</a>
            </div>
            <div class="items">
                <a pageScroll href="#about" [routerLink]="['/about']">About</a>
                <a pageScroll href="#news" [routerLink]="['/news']">Press</a>
            </div>
        </div>
        <div class="social">
            <!-- <div class="btn-gennius" id="Request_a_demo_chat2">
                Request a demo<span></span>
            </div> -->
        </div>
    </div>
    <div class="container footer borde-top">
        <span>© {{YEAR}} <a href="https://tc.milesblue.com/#/miles" target="_blank"> Terms and conditions</a> apply.</span>
        <p>All brand names, logos and/or trademarks are the property of their respective owners, are used for identification purposes only.</p>
    </div>
</footer>
